module.exports = __webpack_public_path__ + "fonts/FuturaStd-Book.724e01df.eot";